import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <!--路由主入口-->
    <router-outlet></router-outlet>
  `
})
export class AppComponent {
}
